export const TRUELARK_LOCATION_HISTORY_LIMIT = 20;
export const TRUELARK_STALE_TIME = 30_000;
